module.exports = __webpack_public_path__ + "files/a57e568119d4170d622f3227eace2903.png";